import { FieldArray, useField } from 'formik'
import { Source } from 'types'
import { Heading } from 'blaze-ui/Heading/Heading'
import { AddWebpageButton } from 'screens/Campaign/CampaignContext/AddWebpageModal/AddWebpageButton'
import { UploadButton } from 'screens/Campaign/CampaignContext/UploadButton'
import { ContextTable } from 'screens/Campaign/CampaignContext/ContextTable'
import { FieldProps } from './Types'
import { Text } from 'blaze-ui/Text/Text'
import React from 'react'
import Styles from './SourcesField.module.scss'
import RegenerateCampaignsStyles from './RegenerateCampaigns.module.scss'
import { useId } from '@react-aria/utils'

export const SourcesField = ({ name }: FieldProps) => {
  const [field] = useField<Array<Source & { save_media?: boolean }>>(name)
  const id = useId()

  return (
    <div role="group" className={Styles.wrapper} aria-labelledby={id}>
      <div className={RegenerateCampaignsStyles.fieldHeading}>
        <Heading level={4} id={id}>
          Upload related materials to inspire richer, more detailed content
        </Heading>
        <Text variant="secondary" color="var(--dark-40)">
          Websites, docs, PDFs, videos, voice notes. We will only extract text from your materials.
        </Text>
      </div>
      <FieldArray name={name}>
        {({ push, remove }) => (
          <>
            {field.value.length < 1 && (
              <div className={Styles.buttons}>
                <AddWebpageButton
                  variant="ghost-tertiary"
                  onSourceCreated={(source, saveMedia) => push({ ...source, save_media: saveMedia })}
                  size="sm"
                  primaryAction="Add"
                />
                <UploadButton variant="ghost-tertiary" onSourceCreated={push} size="sm" />
              </div>
            )}
            {field.value.length > 0 && (
              <>
                <ContextTable
                  sources={field.value}
                  isLoading={false}
                  onSourceCreated={push}
                  onDeleteSource={(source) =>
                    remove(field.value.findIndex((fieldSource) => fieldSource.id === source.id))
                  }
                />
                <div className={Styles.buttons}>
                  <AddWebpageButton
                    variant="ghost-tertiary"
                    onSourceCreated={(source, saveMedia) => push({ ...source, save_media: saveMedia })}
                    size="sm"
                    primaryAction="Add"
                  />
                  <UploadButton variant="ghost-tertiary" onSourceCreated={push} size="sm" />
                </div>
              </>
            )}
          </>
        )}
      </FieldArray>
    </div>
  )
}
